import { ISharepointSettings } from "../models/sharepointSettings";

export const SET_SHAREPOINT_SETTINGS = "SET_SHAREPOINT_SETTINGS";

export const SetSharepointSettings = (settings: ISharepointSettings) => {
    return { type: SET_SHAREPOINT_SETTINGS, payload: settings };
};

